// constants referencing to the css variables of mixins.less

export const BOX_SHADOW_PAPER = 'var(--box-shadow-paper)'
